import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './colorPicker.css';
import { onDidChangeZoomLevel } from '../../../base/browser/browser.js';
import * as dom from '../../../base/browser/dom.js';
import { GlobalMouseMoveMonitor, standardMouseMoveMerger } from '../../../base/browser/globalMouseMoveMonitor.js';
import { Widget } from '../../../base/browser/ui/widget.js';
import { Color, HSVA, RGBA } from '../../../base/common/color.js';
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { editorHoverBackground } from '../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
var $ = dom.$;
export var ColorPickerHeader = /*#__PURE__*/function (_Disposable) {
  _inherits(ColorPickerHeader, _Disposable);

  var _super = _createSuper(ColorPickerHeader);

  function ColorPickerHeader(container, model, themeService) {
    var _this;

    _classCallCheck(this, ColorPickerHeader);

    _this = _super.call(this);
    _this.model = model;
    _this.domNode = $('.colorpicker-header');
    dom.append(container, _this.domNode);
    _this.pickedColorNode = dom.append(_this.domNode, $('.picked-color'));
    var colorBox = dom.append(_this.domNode, $('.original-color'));
    colorBox.style.backgroundColor = Color.Format.CSS.format(_this.model.originalColor) || '';
    _this.backgroundColor = themeService.getColorTheme().getColor(editorHoverBackground) || Color.white;

    _this._register(registerThemingParticipant(function (theme, collector) {
      _this.backgroundColor = theme.getColor(editorHoverBackground) || Color.white;
    }));

    _this._register(dom.addDisposableListener(_this.pickedColorNode, dom.EventType.CLICK, function () {
      return _this.model.selectNextColorPresentation();
    }));

    _this._register(dom.addDisposableListener(colorBox, dom.EventType.CLICK, function () {
      _this.model.color = _this.model.originalColor;

      _this.model.flushColor();
    }));

    _this._register(model.onDidChangeColor(_this.onDidChangeColor, _assertThisInitialized(_this)));

    _this._register(model.onDidChangePresentation(_this.onDidChangePresentation, _assertThisInitialized(_this)));

    _this.pickedColorNode.style.backgroundColor = Color.Format.CSS.format(model.color) || '';
    dom.toggleClass(_this.pickedColorNode, 'light', model.color.rgba.a < 0.5 ? _this.backgroundColor.isLighter() : model.color.isLighter());
    return _this;
  }

  _createClass(ColorPickerHeader, [{
    key: "onDidChangeColor",
    value: function onDidChangeColor(color) {
      this.pickedColorNode.style.backgroundColor = Color.Format.CSS.format(color) || '';
      dom.toggleClass(this.pickedColorNode, 'light', color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : color.isLighter());
      this.onDidChangePresentation();
    }
  }, {
    key: "onDidChangePresentation",
    value: function onDidChangePresentation() {
      this.pickedColorNode.textContent = this.model.presentation ? this.model.presentation.label : '';
    }
  }]);

  return ColorPickerHeader;
}(Disposable);
export var ColorPickerBody = /*#__PURE__*/function (_Disposable2) {
  _inherits(ColorPickerBody, _Disposable2);

  var _super2 = _createSuper(ColorPickerBody);

  function ColorPickerBody(container, model, pixelRatio) {
    var _this2;

    _classCallCheck(this, ColorPickerBody);

    _this2 = _super2.call(this);
    _this2.model = model;
    _this2.pixelRatio = pixelRatio;
    _this2.domNode = $('.colorpicker-body');
    dom.append(container, _this2.domNode);
    _this2.saturationBox = new SaturationBox(_this2.domNode, _this2.model, _this2.pixelRatio);

    _this2._register(_this2.saturationBox);

    _this2._register(_this2.saturationBox.onDidChange(_this2.onDidSaturationValueChange, _assertThisInitialized(_this2)));

    _this2._register(_this2.saturationBox.onColorFlushed(_this2.flushColor, _assertThisInitialized(_this2)));

    _this2.opacityStrip = new OpacityStrip(_this2.domNode, _this2.model);

    _this2._register(_this2.opacityStrip);

    _this2._register(_this2.opacityStrip.onDidChange(_this2.onDidOpacityChange, _assertThisInitialized(_this2)));

    _this2._register(_this2.opacityStrip.onColorFlushed(_this2.flushColor, _assertThisInitialized(_this2)));

    _this2.hueStrip = new HueStrip(_this2.domNode, _this2.model);

    _this2._register(_this2.hueStrip);

    _this2._register(_this2.hueStrip.onDidChange(_this2.onDidHueChange, _assertThisInitialized(_this2)));

    _this2._register(_this2.hueStrip.onColorFlushed(_this2.flushColor, _assertThisInitialized(_this2)));

    return _this2;
  }

  _createClass(ColorPickerBody, [{
    key: "flushColor",
    value: function flushColor() {
      this.model.flushColor();
    }
  }, {
    key: "onDidSaturationValueChange",
    value: function onDidSaturationValueChange(_ref) {
      var s = _ref.s,
          v = _ref.v;
      var hsva = this.model.color.hsva;
      this.model.color = new Color(new HSVA(hsva.h, s, v, hsva.a));
    }
  }, {
    key: "onDidOpacityChange",
    value: function onDidOpacityChange(a) {
      var hsva = this.model.color.hsva;
      this.model.color = new Color(new HSVA(hsva.h, hsva.s, hsva.v, a));
    }
  }, {
    key: "onDidHueChange",
    value: function onDidHueChange(value) {
      var hsva = this.model.color.hsva;
      var h = (1 - value) * 360;
      this.model.color = new Color(new HSVA(h === 360 ? 0 : h, hsva.s, hsva.v, hsva.a));
    }
  }, {
    key: "layout",
    value: function layout() {
      this.saturationBox.layout();
      this.opacityStrip.layout();
      this.hueStrip.layout();
    }
  }]);

  return ColorPickerBody;
}(Disposable);

var SaturationBox = /*#__PURE__*/function (_Disposable3) {
  _inherits(SaturationBox, _Disposable3);

  var _super3 = _createSuper(SaturationBox);

  function SaturationBox(container, model, pixelRatio) {
    var _this3;

    _classCallCheck(this, SaturationBox);

    _this3 = _super3.call(this);
    _this3.model = model;
    _this3.pixelRatio = pixelRatio;
    _this3._onDidChange = new Emitter();
    _this3.onDidChange = _this3._onDidChange.event;
    _this3._onColorFlushed = new Emitter();
    _this3.onColorFlushed = _this3._onColorFlushed.event;
    _this3.domNode = $('.saturation-wrap');
    dom.append(container, _this3.domNode); // Create canvas, draw selected color

    _this3.canvas = document.createElement('canvas');
    _this3.canvas.className = 'saturation-box';
    dom.append(_this3.domNode, _this3.canvas); // Add selection circle

    _this3.selection = $('.saturation-selection');
    dom.append(_this3.domNode, _this3.selection);

    _this3.layout();

    _this3._register(dom.addDisposableGenericMouseDownListner(_this3.domNode, function (e) {
      return _this3.onMouseDown(e);
    }));

    _this3._register(_this3.model.onDidChangeColor(_this3.onDidChangeColor, _assertThisInitialized(_this3)));

    _this3.monitor = null;
    return _this3;
  }

  _createClass(SaturationBox, [{
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var _this4 = this;

      this.monitor = this._register(new GlobalMouseMoveMonitor());
      var origin = dom.getDomNodePagePosition(this.domNode);

      if (e.target !== this.selection) {
        this.onDidChangePosition(e.offsetX, e.offsetY);
      }

      this.monitor.startMonitoring(e.target, e.buttons, standardMouseMoveMerger, function (event) {
        return _this4.onDidChangePosition(event.posx - origin.left, event.posy - origin.top);
      }, function () {
        return null;
      });
      var mouseUpListener = dom.addDisposableGenericMouseUpListner(document, function () {
        _this4._onColorFlushed.fire();

        mouseUpListener.dispose();

        if (_this4.monitor) {
          _this4.monitor.stopMonitoring(true);

          _this4.monitor = null;
        }
      }, true);
    }
  }, {
    key: "onDidChangePosition",
    value: function onDidChangePosition(left, top) {
      var s = Math.max(0, Math.min(1, left / this.width));
      var v = Math.max(0, Math.min(1, 1 - top / this.height));
      this.paintSelection(s, v);

      this._onDidChange.fire({
        s: s,
        v: v
      });
    }
  }, {
    key: "layout",
    value: function layout() {
      this.width = this.domNode.offsetWidth;
      this.height = this.domNode.offsetHeight;
      this.canvas.width = this.width * this.pixelRatio;
      this.canvas.height = this.height * this.pixelRatio;
      this.paint();
      var hsva = this.model.color.hsva;
      this.paintSelection(hsva.s, hsva.v);
    }
  }, {
    key: "paint",
    value: function paint() {
      var hsva = this.model.color.hsva;
      var saturatedColor = new Color(new HSVA(hsva.h, 1, 1, 1));
      var ctx = this.canvas.getContext('2d');
      var whiteGradient = ctx.createLinearGradient(0, 0, this.canvas.width, 0);
      whiteGradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
      whiteGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.5)');
      whiteGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
      var blackGradient = ctx.createLinearGradient(0, 0, 0, this.canvas.height);
      blackGradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
      blackGradient.addColorStop(1, 'rgba(0, 0, 0, 1)');
      ctx.rect(0, 0, this.canvas.width, this.canvas.height);
      ctx.fillStyle = Color.Format.CSS.format(saturatedColor);
      ctx.fill();
      ctx.fillStyle = whiteGradient;
      ctx.fill();
      ctx.fillStyle = blackGradient;
      ctx.fill();
    }
  }, {
    key: "paintSelection",
    value: function paintSelection(s, v) {
      this.selection.style.left = "".concat(s * this.width, "px");
      this.selection.style.top = "".concat(this.height - v * this.height, "px");
    }
  }, {
    key: "onDidChangeColor",
    value: function onDidChangeColor() {
      if (this.monitor && this.monitor.isMonitoring()) {
        return;
      }

      this.paint();
    }
  }]);

  return SaturationBox;
}(Disposable);

var Strip = /*#__PURE__*/function (_Disposable4) {
  _inherits(Strip, _Disposable4);

  var _super4 = _createSuper(Strip);

  function Strip(container, model) {
    var _this5;

    _classCallCheck(this, Strip);

    _this5 = _super4.call(this);
    _this5.model = model;
    _this5._onDidChange = new Emitter();
    _this5.onDidChange = _this5._onDidChange.event;
    _this5._onColorFlushed = new Emitter();
    _this5.onColorFlushed = _this5._onColorFlushed.event;
    _this5.domNode = dom.append(container, $('.strip'));
    _this5.overlay = dom.append(_this5.domNode, $('.overlay'));
    _this5.slider = dom.append(_this5.domNode, $('.slider'));
    _this5.slider.style.top = "0px";

    _this5._register(dom.addDisposableGenericMouseDownListner(_this5.domNode, function (e) {
      return _this5.onMouseDown(e);
    }));

    _this5.layout();

    return _this5;
  }

  _createClass(Strip, [{
    key: "layout",
    value: function layout() {
      this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
      var value = this.getValue(this.model.color);
      this.updateSliderPosition(value);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var _this6 = this;

      var monitor = this._register(new GlobalMouseMoveMonitor());

      var origin = dom.getDomNodePagePosition(this.domNode);
      dom.addClass(this.domNode, 'grabbing');

      if (e.target !== this.slider) {
        this.onDidChangeTop(e.offsetY);
      }

      monitor.startMonitoring(e.target, e.buttons, standardMouseMoveMerger, function (event) {
        return _this6.onDidChangeTop(event.posy - origin.top);
      }, function () {
        return null;
      });
      var mouseUpListener = dom.addDisposableGenericMouseUpListner(document, function () {
        _this6._onColorFlushed.fire();

        mouseUpListener.dispose();
        monitor.stopMonitoring(true);
        dom.removeClass(_this6.domNode, 'grabbing');
      }, true);
    }
  }, {
    key: "onDidChangeTop",
    value: function onDidChangeTop(top) {
      var value = Math.max(0, Math.min(1, 1 - top / this.height));
      this.updateSliderPosition(value);

      this._onDidChange.fire(value);
    }
  }, {
    key: "updateSliderPosition",
    value: function updateSliderPosition(value) {
      this.slider.style.top = "".concat((1 - value) * this.height, "px");
    }
  }]);

  return Strip;
}(Disposable);

var OpacityStrip = /*#__PURE__*/function (_Strip) {
  _inherits(OpacityStrip, _Strip);

  var _super5 = _createSuper(OpacityStrip);

  function OpacityStrip(container, model) {
    var _this7;

    _classCallCheck(this, OpacityStrip);

    _this7 = _super5.call(this, container, model);
    dom.addClass(_this7.domNode, 'opacity-strip');

    _this7._register(model.onDidChangeColor(_this7.onDidChangeColor, _assertThisInitialized(_this7)));

    _this7.onDidChangeColor(_this7.model.color);

    return _this7;
  }

  _createClass(OpacityStrip, [{
    key: "onDidChangeColor",
    value: function onDidChangeColor(color) {
      var _color$rgba = color.rgba,
          r = _color$rgba.r,
          g = _color$rgba.g,
          b = _color$rgba.b;
      var opaque = new Color(new RGBA(r, g, b, 1));
      var transparent = new Color(new RGBA(r, g, b, 0));
      this.overlay.style.background = "linear-gradient(to bottom, ".concat(opaque, " 0%, ").concat(transparent, " 100%)");
    }
  }, {
    key: "getValue",
    value: function getValue(color) {
      return color.hsva.a;
    }
  }]);

  return OpacityStrip;
}(Strip);

var HueStrip = /*#__PURE__*/function (_Strip2) {
  _inherits(HueStrip, _Strip2);

  var _super6 = _createSuper(HueStrip);

  function HueStrip(container, model) {
    var _this8;

    _classCallCheck(this, HueStrip);

    _this8 = _super6.call(this, container, model);
    dom.addClass(_this8.domNode, 'hue-strip');
    return _this8;
  }

  _createClass(HueStrip, [{
    key: "getValue",
    value: function getValue(color) {
      return 1 - color.hsva.h / 360;
    }
  }]);

  return HueStrip;
}(Strip);

export var ColorPickerWidget = /*#__PURE__*/function (_Widget) {
  _inherits(ColorPickerWidget, _Widget);

  var _super7 = _createSuper(ColorPickerWidget);

  function ColorPickerWidget(container, model, pixelRatio, themeService) {
    var _this9;

    _classCallCheck(this, ColorPickerWidget);

    _this9 = _super7.call(this);
    _this9.model = model;
    _this9.pixelRatio = pixelRatio;

    _this9._register(onDidChangeZoomLevel(function () {
      return _this9.layout();
    }));

    var element = $('.colorpicker-widget');
    container.appendChild(element);
    var header = new ColorPickerHeader(element, _this9.model, themeService);
    _this9.body = new ColorPickerBody(element, _this9.model, _this9.pixelRatio);

    _this9._register(header);

    _this9._register(_this9.body);

    return _this9;
  }

  _createClass(ColorPickerWidget, [{
    key: "layout",
    value: function layout() {
      this.body.layout();
    }
  }]);

  return ColorPickerWidget;
}(Widget);